import { CircularProgressbar } from "react-circular-progressbar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const GoalsData = ({ setShow, setGoalId, searchTerm, filteredData }) => {
  const loading = useSelector((state) => state.goals.loading);
  const error = useSelector((state) => state.goals.error);
  const navigate = useNavigate();

  const handleClick = (id) => {
    const route = `/goaldetailpage`;
    navigate(route, { state: { id } });
  };

  const handleDeleteModal = (id, event) => {
    event.stopPropagation();
    setShow(true);
    setGoalId(id);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // Sort goalsData by start_date in descending order (newest first)
  const sortedGoalsData = filteredData
    ? [...filteredData].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
    : [];

  if (loading) {
    return (
      <>
        <main className="col-md-12">
          <h1 className="h2 py-2">
            <i className="fa-solid fa-spinner fa-spin"></i>
          </h1>
        </main>
      </>
    );
  }

  return (
    <>
      {sortedGoalsData && sortedGoalsData.length > 0 ? (
        sortedGoalsData.map((curData) => {
          const { id, goal_name, category, start_date, end_date, status } = curData;
          const randomPercentage = Math.floor(Math.random() * 101);
          const formattedStartDate = formatDate(start_date);
          const formattedEndDate = formatDate(end_date);

          return (
            <tr className="clickable" key={id} onClick={() => handleClick(id)}>
              <td>{goal_name}</td>
              <td>{category}</td>
              <td>{formattedStartDate}</td>
              <td>{formattedEndDate}</td>
              <td>{status}</td>
              <td className="circlep">
                <CircularProgressbar value={randomPercentage} text={`${randomPercentage}%`} />
              </td>
              <td>
                <button
                  className="custom-button"
                  onClick={(event) => handleDeleteModal(id, event)}
                >
                  <i className="fa fa-trash" style={{color:"red"}} aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="7">No goals found.</td>
        </tr>
      )}
    </>
  );
};

export default GoalsData;